<template>
    <div>
        <loading :active='isLoading' :is-full-page="fullPage" :loader='loader' />
        <section class="sell_your_device_dashboard_default text-center" style="min-height:80vh">
            <div class="container-fluid">
                <div class="service_top_section__img_section text-center" :style="{'width':'100%'}">
                    <div class="row">
                        <div class="col-md-4 col-xl-3 col-lg-3 col-sm-4">
                            <Sidebar></Sidebar>
                        </div>
                        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 mb-4 cat-block-device">
                            <div class="container-fluid">
                                 <div class="invoice-box bg-white">
                                    <table cellpadding="0" cellspacing="0">
                                        <tr>
                                            <td colspan="4">
                                                <table>
                                                    <tr>
                                                        <!-- <td class="title">
                                                            <img v-if="dataList.header_logo" :src="'./upload/header_logo/' + dataList.header_logo" style="width: 100%; max-width: 150px;">
                                                        </td> -->
                                                        <td>
                                                            Invoice #: {{ $route.params.invoiceID }} 
                                                            <br>
                                                            <!-- Created: {{ orderDetailData.invoice.created_at | formatDate }} -->
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr class="information">
                                            <td colspan="4">
                                                <table>
                                                    <tr>
                                                        <td>
                                                            <b>IGeek Repair Center</b> <br>
                                                            sales@igeekrepaircenter.com <br>
                                                            Call: (248) 834-3357
                                                        </td>
                                                        <td>
                                                            {{ orderDetailData.customer.full_name }} <br>
                                                            {{ orderDetailData.customer.phone }} <br>
                                                            {{ orderDetailData.customer.address_1 }}
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr class="heading">
                                            <td>
                                                Item
                                            </td>
                                            <td align="right">
                                                Quantity
                                            </td>
                                            <td align="right">
                                                Unit Price
                                            </td>
                                            <td align="right">
                                                Price
                                            </td>
                                        </tr>
        
                                        <tr class="item" v-for="(row,index) in orderDetailData.invoiceItems" :key="index">
                                            <td>
                                                {{ row.product_name }}
                                            </td>
                                            <td align="right">
                                                {{ row.quantity }}
                                            </td>
                                            <td align="right">
                                                ${{ row.unit_price }}
                                            </td>
                                            <td align="right">
                                                ${{ row.total_price }}
                                            </td>
                                        </tr>
                                   
                                        <tr class="total">
                                            <td colspan="3"></td>
                                            <td>
                                                Total: ${{ orderDetailData.invoice.price }}
                                            </td>
                                        </tr>
                                         <tr class="heading">
                                            <td colspan="3">
                                                Payment Method
                                            </td>
                                            <td>
                                                {{ orderDetailData.payment.payment_type_name }}
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>         
                        </div>
                    </div>
                </div>
            </div>
        </section>  
    </div>
</template>

<script>
    import Loading from "vue-loading-overlay";
    import Sidebar from "../layout/Sidebar.vue";
    import {authHeader} from "../../auth";

    export default {
        name: "OrderDetail",
        components: {
            Sidebar,
            Loading
        },
        data() {
            return {
                isLoading: false,
                fullPage: true,
                loader: "bars",
                getOrderURL: "api/get-detail-order",
                orderDetailData: [],
                message: "",
                statusMessage: "No Record Found"
            }
        },
        created() {
            document.title = 'Geek Buy Back - Order Details';
            //this.getDataList({'url': 'site/info'}); 
            this.getOrderDetails();
        },
        methods:{
            getOrderDetails: function() {
                this.isLoading = true;
                var config = {
                    method: "GET",
                    url: this.$api + this.getOrderURL + '/' + this.$route.params.invoiceID,
                    headers: authHeader()
                };
                
                this.$axios(config).then(response => {
                    console.log(response.data);
                    this.orderDetailData = response.data;
                    if(this.orderDetailData.length == 0)
                    {
                        this.message = this.statusMessage;
                    }
                    this.isLoading = false;
                }).catch(e => {
                    console.log(e);
                    this.isLoading = false;
                });
            },
        }
    }
</script>
<style src="./css/common.css"></style>